'use strict';

var React = require('react');

var SvgSoftPackMajor = function SvgSoftPackMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 1.5v17c0 .8.7 1.5 1.5 1.5h13.1c.8 0 1.5-.7 1.5-1.5v-17c0-.8-.7-1.5-1.5-1.5h-13.1c-.8 0-1.5.7-1.5 1.5zm14 16.5h-12v-16h12v16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4h-3v2h3v-2zm11 0h-3v2h3v-2zm-5 0h-4v2h4v-2zm-2 6h-4v2h4v-2zm2 4h-6v2h6v-2z"
  }));
};

exports.SvgSoftPackMajor = SvgSoftPackMajor;
